import { context, log } from "./Contexts/Context"

export function rootRunWrapper(fn: () => Promise<void>): void {
    (async () => {
        try {
            await context.createLocalContext(async () => {
                await fn()
            })
        } catch (e) {
            rootExceptionHandler(e)
        }
    })().catch(e => {
        rootExceptionHandler(e)
    })
}

export function rootExceptionHandler(e: unknown): void {
    let errorMessage = "Unknown error in rootExceptionHandler()"

    if (e instanceof Error) {
        errorMessage = e.message
    }
    if(typeof e === "string") {
        errorMessage = e
    }

    try {
        log.error("Exiting because of error at root handler: " + errorMessage)
        if (e instanceof Error && e.stack) {
            log.error(e.stack)
        }
    }
    catch (e) {
        console.error("Exiting because of error at root handler: " + errorMessage)
        if (e instanceof Error && e.stack) {
            console.error(e.stack)
        }
    }

    // For backends, give up and let the systemd service restart us
    if(!context.application.isFrontend) {
        process.exit()
    }
}
